














import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
@Component({
  components: {
    Location: () => import('@/components/base/InsLocation.vue')
  }
})
export default class InsCmsContent extends Vue {
  CateName: string = '';
  content: object={};
  CategoryName: string = '';
  HomeName: string = '';

  // 获取关于我们cms内容
  getContent () {
    this.$Api.cms.getContentByDevice({ ContentId: this.id, IsMobile: this.isMobile }).then(result => {
      this.content = result.CMS;
      this.CateName = result.CMS.Title;
      this.CategoryName = result.CMS.Category.Name;
      // this.$HiddenLayer();
      console.log(result, 'CMS');
    });
  }

  get id () {
    return this.$route.params.id;
  }

  get isMobile () {
    return this.$store.state.isMobile;
  }

  created () {
    if ((window as any).__PRERENDER_INJECTED) {
      try {
        let seoData = require('../../sdk/common/SeoData');
        let keywords = document.createElement('meta');
        keywords.setAttribute('name', 'keywords');
        keywords.setAttribute('content', seoData.seoItem['cms' + this.id].keyword);
        document.head.appendChild(keywords);
        let description = document.createElement('meta');
        description.setAttribute('name', 'description');
        description.setAttribute('content', seoData.seoItem['cms' + this.id].description);
        document.head.appendChild(description);
        document.title = seoData.seoItem['cms' + this.id].title;
        document.dispatchEvent(new Event('render-event'));
      } catch (e) {
        console.log('當前頁面無需SEO。');
      }
    }
  }

  mounted () {
    this.getContent();
  }

  @Watch('isMobile', { deep: true })
  onMediaChange () {
    this.getContent();
  }

  @Watch('id', { deep: true })
  onKeyChange () {
    this.content = {};
    this.getContent();
  }
}
